import { atom } from 'jotai';

export const drawerIsOpenAtom = atom(false);

drawerIsOpenAtom.debugLabel = 'DemandEventDrawerState.drawerIsOpenAtom';
